import { env } from '@helpers/env';

export function generateConfig() {
    return {
        domain: env('NEXT_PUBLIC_DOMAIN') ?? '',
        version: process.env.APP_VERSION ?? '',
        siteUrl: env('NEXT_PUBLIC_SITE_URL') ?? '',
        bench: env('NEXT_PUBLIC_BENCH') ?? '',
        api: {
            url: process.env.API_URL ?? env('NEXT_PUBLIC_API_URL') ?? '',
        },
        b2r: {
            url: process.env.B2R_URL ?? env('NEXT_PUBLIC_B2R_URL') ?? '',
        },
        refcli: {
            url: process.env.REFCLI_URL ?? env('NEXT_PUBLIC_B2R_URL') ?? '',
        },
        odr: {
            adminUrl: process.env.PALPATINE_ODR_API ?? env('NEXT_PUBLIC_PALPATINE_ODR_API') ?? '',
        },
        productAlert: {
            url: env('NEXT_PUBLIC_PRODUCT_ALERT_URL') ?? '',
        },
        proxy: {
            url: process.env.PROXY_URL,
        },
        skeepers: {
            url: process.env.SKEEPERS_URL,
            id: process.env.SKEEPERS_ID,
            // API v2 OAuth2
            apiUrl: process.env.SKEEPERS_API_URL,
            authUrl: process.env.SKEEPERS_AUTH_URL,
            clientId: process.env.SKEEPERS_CLIENT_ID,
            clientSecret: process.env.SKEEPERS_CLIENT_SECRET,
        },
        smartTraffik: {
            url: env('NEXT_PUBLIC_SMART_TRAFFIK_URL') ?? '',
            apikey: env('NEXT_PUBLIC_SMART_TRAFFIK_APIKEY') ?? '',
        },
        webcallback: {
            pro: {
                url: process.env.WEB_CALLBACK_PRO_URL ?? '',
                id: process.env.WEB_CALLBACK_PRO_ID ?? '',
                key: process.env.WEB_CALLBACK_PRO_KEY ?? '',
            },
            acq: {
                url: process.env.WEB_CALLBACK_ACQ_URL ?? '',
            },
        },
        eresa: {
            locator: env('NEXT_PUBLIC_ERESA_LOCATOR') ?? '',
            preorder: env('NEXT_PUBLIC_ERESA_PREORDER') ?? '',
        },
        prisme: {
            url: env('NEXT_PUBLIC_PRISME_URL') ?? '',
            active: process.env.LOG_PRISME_ACTIVE
                ? process.env.LOG_PRISME_ACTIVE === 'true'
                : env('NEXT_PUBLIC_LOG_PRISME_ACTIVE') === 'true',
            authorizeUrls: [
                env('NEXT_PUBLIC_DOMAIN'),
                env('NEXT_PUBLIC_B2R_URL'),
                env('NEXT_PUBLIC_SMART_TRAFFIK_URL'),
                env('NEXT_PUBLIC_ERESA_LOCATOR'),
                env('NEXT_PUBLIC_ERESA_PREORDER'),
            ].filter((url) => url !== undefined),
        },
        oauth2: {
            clientId: env('NEXT_PUBLIC_OAUTH2_CLIENT_ID') ?? '',
            url: env('NEXT_PUBLIC_OAUTH2_URL') ?? '',
            authorizationUrl: env('NEXT_PUBLIC_OAUTH2_AUTHORIZATION_URL') ?? '',
            tokenUrl: process.env.OAUTH2_TOKEN_URL,
            userInfoUrl: process.env.OAUTH2_USERINFO_URL,
        },
        defaultPlans: {
            smartChange: {
                acquisition: Number.parseInt(env('NEXT_PUBLIC_DEFAULT_PLAN_SMART_CHANGE') ?? ''),
                renewal:
                    env('NEXT_PUBLIC_DEFAULT_RENEWAL_PLAN_SMART_CHANGE')
                        ?.split(',')
                        .map((n) => Number.parseInt(n, 10)) ?? [],
            },
            classic: {
                acquisition: Number.parseInt(env('NEXT_PUBLIC_DEFAULT_PLAN_CLASSIC') ?? ''),
                renewal:
                    env('NEXT_PUBLIC_DEFAULT_RENEWAL_PLAN_CLASSIC')
                        ?.split(',')
                        .map((n) => Number.parseInt(n, 10)) ?? [],
            },
            simulator: {
                mobile: env('NEXT_PUBLIC_DEFAULT_SIMULATOR_MOBILE_PLAN') ?? '',
                fai: env('NEXT_PUBLIC_DEFAULT_SIMULATOR_FAI_PLAN') ?? '',
            },
            hotspot: env('NEXT_PUBLIC_DEFAULT_PLAN_HOTSPOT') ?? '',
            kidsWatch: {
                urlKey: env('NEXT_PUBLIC_KIDS_WATCH_URL_KEY') ?? 'tcl-kids-watch-mt48',
                planGencode: env('NEXT_PUBLIC_KIDS_WATCH_PLAN_GENCODE') ?? '6975',
                optionGencode: env('NEXT_PUBLIC_KIDS_WATCH_OPTION_GENCODE') ?? '11148',
            },
        },
        assets: {
            images: {
                url: env('NEXT_PUBLIC_IMAGES_URL') ?? '',
            },
            cmsImages: {
                url: env('NEXT_PUBLIC_CONTENT_EDITOR_IMAGES') ?? '',
            },
            partials: {
                url: process.env.PARTIALS_URL ?? env('NEXT_PUBLIC_PARTIALS_URL') ?? '',
                header: {
                    default: env('NEXT_PUBLIC_HEADER_PARTIAL_URL') ?? '',
                    light: env('NEXT_PUBLIC_HEADER_PARTIAL_URL_LIGHT') ?? '',
                    renewal: env('NEXT_PUBLIC_HEADER_PARTIAL_URL_RENEWAL') ?? '',
                },
            },
            sliders: {
                script: env('NEXT_PUBLIC_ASSETS_SLIDERS_SCRIPT') ?? '',
            },
            palpatine: {
                plans: process.env.PALPATINE_FORFAITS_API ?? env('NEXT_PUBLIC_PALPATINE_FORFAITS_API') ?? '',
                sticker: process.env.PALPATINE_STICKER_API,
                product: process.env.PALPATINE_PRODUCT_API,
                fai: process.env.PALPATINE_FAI_API,
            },
            trilogy: {
                script: env('NEXT_PUBLIC_ASSETS_TRILOGY_SCRIPT') ?? '',
            },
        },
        thumbor: {
            active: env('NEXT_PUBLIC_THUMBOR_ACTIVE') === 'true',
            url: env('NEXT_PUBLIC_THUMBOR_URL') ?? '',
        },
        crossSell: {
            active: env('NEXT_PUBLIC_CROSS_SELL_ACTIVE') === 'true',
            accessoriesActive: env('NEXT_PUBLIC_CROSS_SELL_ACCESSORIES_ACTIVE') === 'true',
            maximumAccessories: Number.parseInt(env('NEXT_PUBLIC_CROSS_SELL_MAX_ACCESSORIES') ?? ''),
        },
        tracking: {
            env: env('NEXT_PUBLIC_TRACKING_ENV') as 'PROD' | 'TEST',
            enabled: env('NEXT_PUBLIC_TRACKING_ENABLED') === 'true',
            host: env('NEXT_PUBLIC_TRACKING_HOST') ?? '',
            debug: env('NEXT_PUBLIC_TRACKING_DEBUG') === 'true',
        },
        logger: {
            http: {
                logCached: process.env.LOG_HTTP_CACHED === 'true',
            },
        },
        cache: {
            ttl: {
                products: env('NEXT_PUBLIC_CACHE_TTL_PRODUCTS') ?? '',
                productDetail: env('NEXT_PUBLIC_CACHE_TTL_PRODUCT_DETAIL') ?? '',
                productsStocks: env('NEXT_PUBLIC_CACHE_TTL_PRODUCTS_STOCKS') ?? '',
                cms: env('NEXT_PUBLIC_CACHE_TTL_CMS') ?? '',
                odr: env('NEXT_PUBLIC_CACHE_TTL_ODR') ?? '',
                user: env('NEXT_PUBLIC_CACHE_TTL_USER') ?? '',
            },
        },
        monitoring: {
            active: env('NEXT_PUBLIC_SENTRY_ACTIVE') === 'true' || process.env.SENTRY_ACTIVE === 'true',
            url: env('NEXT_PUBLIC_SENTRY_DSN'),
            bench: env('NEXT_PUBLIC_HELM_RELEASE_NAME'),
            debug: env('NEXT_PUBLIC_SENTRY_DEBUG') === 'true',
        },
        widget: {
            weto: {
                url: env('NEXT_PUBLIC_WETO_URL') ?? '',
            },
        },
        yamaReferrers: env('NEXT_PUBLIC_YAMA_REFERRERS')?.split(',') ?? [],
        lmReferrers: env('NEXT_PUBLIC_LM_REFERRERS')?.split(',') ?? [],
        lmPartner: JSON.parse(env('NEXT_PUBLIC_LM_PARTNER') ?? '[]'),
        axios: {
            timeout: Number.parseInt(env('NEXT_PUBLIC_AXIOS_TIMEOUT') ?? ''),
            cmsTimeout: Number.parseInt(env('NEXT_PUBLIC_CMS_AXIOS_TIMEOUT') ?? '') || 3000,
        },
        features: {
            easyTradeInActivated: process.env.EASY_TRADE_IN_ENABLED === 'true',
        },
    };
}

export const isServer = () => {
    return typeof window === 'undefined';
};
